import {inject} from '@angular/core';
import {type ResolveFn, Router} from '@angular/router';
import {AuthenticationService} from '@authentication/authentication.service';
import {type ResourceResponse, ResourceService} from '@middleware';
import {ResourcePermissionsFlags, SearchFilterMap, SearchParamMap} from '@models/search';
import {SearchService} from '@services/search/search.service';
import {catchError, EMPTY, from, Observable} from 'rxjs';
import {filter, map, switchMap} from 'rxjs/operators';

export const resourceResolver: ResolveFn<(ResourceResponse & ResourcePermissionsFlags) | null> = (route, _state) => {
  const router = inject(Router);
  const searchService = inject(SearchService);
  const authService = inject(AuthenticationService);
  const resourceService = inject(ResourceService);

  const id = route.params['id'];
  const searchFilters: SearchFilterMap['Resources'] = {id: {terms: id}};
  const searchParams: SearchParamMap['Resources'] = {
    public_view: !authService.isLoggedIn(),
    page: 1,
    per_page: 20,
  };

  /** TODO: Cache the result from isLoggedIn() to reduce redundant calls to the auth service */
  let result: Observable<ResourceResponse & ResourcePermissionsFlags>;
  // First, use the search service to get the initial resource for public view
  result = from(searchService.searchByID(searchFilters, searchParams, 'Resources'));
  // If the user is logged in, fetch the full resource data
  if (authService.isLoggedIn()) {
    result = result.pipe(
      switchMap(searchResult =>
        resourceService.getResource(id).pipe(map(resourceResult => ({...searchResult, ...resourceResult}))),
      ),
    );
  }
  result = result.pipe(
    filter(res => !!res),
    catchError(ex => {
      console.error('Error in resolver:', ex);
      router.navigate(['/404']);
      return EMPTY;
    }),
  );
  return result;
};
